<template>
  <div class="content">
    <img src="../assets/news_banner.png" style="width:100%;height:100%;margin-bottom:-8px;">
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Company</el-breadcrumb-item>
      <el-breadcrumb-item>Events&News</el-breadcrumb-item>
      <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="message" style="padding-bottom: 0px;">
      <h1>{{ title }}</h1>
      <p class="p1">{{ createTime }}</p>
      <p class="p2" v-html=content></p>
    </div>
  </div>
</template>
<script>
import {  NewsEventsDetail } from '@/api/index' ;
    export default {
        name: 'Newsdetail',
        data () {
            return {
              id: '',
              title: '',
              created: '',
              content: '',
            }
        },
        created() {
          console.log(this.$route, 'this.$route');
          console.log(this.$route.query, 'this.$route.query');
          this.id = this.$route.query.id
          this.getNewsDetail(this.id)
        },
        methods: {
          // 获取product 详情
          getNewsDetail(id) {
              NewsEventsDetail({id: id }).then((res) => {
                console.log(res, 'res');
                this.title = res.title;
                this.created = res.created;
                this.content = res.content;
              });
          },
        },
        mounted() {
        },
    }
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
}
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
.message {
  padding: 50px 119px 100px 119px !important;
}
.message h1 {
  font-size: 30px;
  color: #000000;
  font-weight: bold;
}
.message .p1 {
  color: #8d8d8d;
  font-size: 16px;
  margin:48px 0 37px 0;
}
.message .p2 {
  color: #343434;
  font-size: 16px;
  line-height: 30px;
}
::v-deep .el-breadcrumb__inner.is-link {
  font-weight: 400;
}
</style>